export const onClientEntry = () => {
  if (typeof window === 'undefined') return
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}

export const onInitialClientRender = () => {
  if (typeof window !== 'undefined') window.scrollTo(0, 0)
  document.documentElement.style.visibility = 'visible'
}

export const shouldUpdateScroll = () => [0, 0]
